// src/components/RetrySteps.js
import { useEffect, useRef } from "react";
import incode from "../services/incode"; // Asegúrate de que la ruta sea correcta

const RetrySteps = ({ session, onSuccess, onError, numberOfTries }) => {
  const containerRef = useRef();
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      return;
    }
    incode.renderRetrySteps(
      containerRef.current,
      {
        token: session, // Usa session.token
        numberOfTries,
      },
      {
        onSuccess,
        onError,
      }
    );
    isMounted.current = true;
  }, [onSuccess, onError, session, numberOfTries]);

  return <div ref={containerRef}></div>;
};

export default RetrySteps;
